import os from 'os';
import path from 'path';
import { userPreferencesFileName } from '../constants.js';

let mockUserPreferencesDir: string | undefined;

/**
 * Path to the user-level preferences file.
 */
export function getUserPreferencesPath(): string {
  return path.join(mockUserPreferencesDir || os.homedir(), userPreferencesFileName);
}

/**
 * For testing only: use this folder instead of the home directory for the user preferences.
 */
export function setMockUserPreferencesDir(newPath: string): void {
  mockUserPreferencesDir = newPath;
}

/**
 * Get the currently set mock user preferences directory.
 * @internal
 */
export function _getMockUserPreferencesDir(): string | undefined {
  return mockUserPreferencesDir;
}
